module.exports = __webpack_public_path__ + "img/kyc.89d33f5.webp";